import apiClient from '@shared/api/apiClient';

/**
 * tryRefreshAccessToken
 * - Refresh Token(HttpOnly 쿠키)을 기반으로 accessToken 재발급을 시도합니다.
 * - 쿠키가 없거나 만료/무효인 경우 null을 반환합니다.
 *
 * [이슈 2024.12] refresh 요청 timeout 설정 추가
 *
 * 기존 문제:
 * - apiClient의 기본 timeout(5초)이 적용되어 네트워크 지연 시 refresh도 실패
 * - refresh 실패 시 사용자가 강제 로그아웃되어 불편함 발생
 *
 * 해결:
 * - refresh 요청에 별도의 긴 timeout(15초) 적용
 * - 네트워크가 느려도 토큰 갱신 성공 가능성 높임
 *
 * @returns {Promise<string|null>} 재발급된 accessToken 또는 null
 */
export default async function tryRefreshAccessToken() {
  const response = await apiClient.post('/v1/auth/refresh', null, {
    withAuth: false,
    withCredentials: true, // HttpOnly 쿠키 전송 필수 (WebView 등에서 누락 방지)
    /**
     * [추가] refresh 요청 전용 timeout
     * 일반 API보다 긴 timeout을 적용하여 네트워크 지연에도 안정적으로 처리
     * apiClient 기본값(30초)과 별개로 명시적 설정
     */
    timeout: 15000,
  });
  return response?.data?.resultData?.accessToken ?? null;
}
